import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserActivityLogsBody } from '@zeeve-platform/user-activity-logs';
import BaseUrls from '../../utils/baseUrls';
import MyDetails from './myDetails';
import MyCloud from './myCloud/myCloud';
import NetworkInviteBody from './networkInviteBody';
import ApiCredential from './apiCreds/accessCredential';
import { prefixPath } from '../../utils/helpers';
import InviteHelper from '../../utils/inviteHelper';

import SubscriptionBody from './subscription/subscription';
import apiBackendInstance from '../../utils/axios';
import CommunicationChannelComponent from './communicationChannel/communicationChannelBody';

/* eslint-disable jsx-a11y/label-has-associated-control */
const MyAccountBody = () => {
  const location: any = useLocation();
  const [page, setPage] = useState(location?.state?.value || '');
  const theme = BaseUrls.getkey();
  const userIcon = `img/${theme}/user.svg`;
  const keyIcon = `img/${theme}/key.svg`;
  const cloudIcon = `img/${theme}/SoundCloud.svg`;
  const marketIcon = `img/${theme}/shoppingcart.svg`;
  const activitylogIcon = `img/${theme}/info.svg`;
  const commChannelIcon = `img/${theme}/message.svg`;

  const View = () => {
    switch (page) {
      case 'myProfile':
        return <MyDetails />;
      case 'myCloud':
        return <MyCloud />;
      case 'apicredential':
        return <ApiCredential />;
      case 'subscription':
        return <SubscriptionBody />;
      case 'networkInvite':
        return <NetworkInviteBody />;
      case 'activitylogs':
        return (
<UserActivityLogsBody
theme={theme}
apiBackendInstance={apiBackendInstance}
showFilters
filters={{}}
appBackendUrl={BaseUrls.getApplicationBackendUrl()}
/>
        );
      case 'communicationChannel':
        return <CommunicationChannelComponent />;
      default: return <MyDetails />;
    }
  };
  const toInvites = prefixPath('/invitation');
  const networkInvite = ['nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'activeTabColor'];
  const [tabColor, setTabColor] = useState(
    location?.state?.value === 'networkInvite' ? networkInvite
      : ['activeTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor'],
  );
  return (
    <section className="px-5 col-12">
      <div className="cardBlack">
        <div className="row mt-2">
          <div className="col-lg-6 mt-2 col-xl-6 col-sm-6 col-xs-6 cursor">
            <h5 className="mt-2 all-color">My Account</h5>
            <p className="manage-sub">
              Manage your subscription and cloud settings
            </p>
          </div>
        </div>
        {/* navbar starts here */}
        <ul className="nav nav-tabs mt-4" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${tabColor[0]}`}
              onClick={() => { setTabColor(['activeTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor']); setPage('myProfile'); }}
              type="button"
            >
              <img className="mx-1" src={userIcon} alt="" />
              My Profile
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${tabColor[1]}`}
              onClick={() => { setTabColor(['nonActiveTabColor', 'activeTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor']); setPage('myCloud'); }}
              type="button"
            >
              <img className="mx-1" src={cloudIcon} alt="" />
              My Cloud
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${tabColor[2]}`}
              onClick={() => { setTabColor(['nonActiveTabColor', 'nonActiveTabColor', 'activeTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor']); setPage('communicationChannel'); }}
              type="button"
            >
              <img className="mx-1" src={commChannelIcon} alt="" />
              Notifications
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${tabColor[3]}`}
              type="button"
              onClick={() => { setTabColor(['nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'activeTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor']); setPage('apicredential'); }}
            >
              <img className="mx-1" src={keyIcon} alt="" />
              API Credentials
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${tabColor[4]}`}
              type="button"
              onClick={() => { setTabColor(['nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'activeTabColor', 'nonActiveTabColor', 'nonActiveTabColor']); setPage('subscription'); }}
            >
              <img className="mx-1" src={marketIcon} alt="" />
              Subscriptions
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${tabColor[5]}`}
              type="button"
              onClick={() => { setTabColor(['nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'activeTabColor', 'nonActiveTabColor']); setPage('activitylogs'); }}
            >
              <img className="mx-1" src={activitylogIcon} alt="" />
              Activity Logs
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${tabColor[6]}`}
              onClick={() => { setTabColor(['nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'nonActiveTabColor', 'activeTabColor']); setPage('networkInvite'); }}
              type="button"
            >
              <img className="mx-1" src={userIcon} alt="" />
              Network Invites
            </button>
          </li>
          {
            InviteHelper()
            && (
              <li className="nav-item" role="presentation">
                <Link to={toInvites} style={{ textDecoration: 'none' }}>
                  <button
                    className={`nav-link ${tabColor[3]}`}
                    type="button"
                  >
                    <i className="fa fa-envelope-o p-1" />
                    Invites
                  </button>
                </Link>
              </li>
            )
          }
        </ul>
        <div className="tab-content" id="myTabContent">
          {View()}
        </div>
      </div>
    </section>

  );
};
export default MyAccountBody;
